import React, { useCallback } from "react";
import { Draggable, DraggableProvided } from "react-beautiful-dnd";
import { observer } from "mobx-react-lite";

import "../DragAndDropTable.scss";
import { translationService } from "../../../services/translation/TranslationService";
import {
  DetailType,
  DetailTypeTranslations,
} from "../../../pages/settings/project-details/components/DetailType";
import Svg from "../../svg/Svg";
import { Hamburger } from "../../svg/svgImageList";
import { CustomProperty } from "../../../services/organization/ProjectPropertyStorage";

interface DragAndDropItemProps {
  data: CustomProperty;
  index: number;
  rowClickCallback: (item: any) => void;
}

interface ItemContentProps extends DragAndDropItemProps {
  provided: DraggableProvided;
}

export default observer(function DragAndDropItem(props: DragAndDropItemProps) {
  return (
    <>
      <Draggable draggableId={props.data.id.toString()} index={props.index}>
        {(provided) => {
          return (
            <div
              id={`row-${props.data.id.toString()}`}
              className="dnd-table-row"
              ref={provided.innerRef}
              {...provided.draggableProps}
            >
              <ItemContent
                provided={provided}
                data={props.data}
                index={props.index}
                rowClickCallback={props.rowClickCallback}
              />
            </div>
          );
        }}
      </Draggable>
    </>
  );
});

const ItemContent = observer((props: ItemContentProps) => {
  const handleRowClick = useCallback(() => {
    props.rowClickCallback!(props.data);
  }, [props]);

  const getTypeTranslation = useCallback(() => {
    const typeKey =
      Object.keys(DetailType).find((key) => DetailType[key] === props.data.type) || "";
    return DetailTypeTranslations[typeKey];
  }, [props.data.type]);

  return (
    <>
      <div className="dnd-table-cell drag-icon align-left" {...props.provided.dragHandleProps}>
        <Svg svg={Hamburger} width={20} height={11.5} />
      </div>
      <div className="row-container clickable" onClick={handleRowClick}>
        <div className="dnd-table-cell">{props.data.label}</div>
        <div className="dnd-table-cell">{translationService.translate(getTypeTranslation())}</div>
      </div>
    </>
  );
});
